import { Dayjs } from "dayjs";
import create from "zustand";
import { ResourceSelectionState } from "../types/Dashboard";

export enum DateType {
    PURCHASE_DATE = "createdAt",
    ARRIVAL_DATE = "items.arrivalDate",
}

export interface PurchaseFilter {
    date: DateType;
    type: ResourceSelectionState;
    product: ResourceSelectionState;
    status: ResourceSelectionState;
    balance: ResourceSelectionState;
    dispute: ResourceSelectionState;
    source: ResourceSelectionState;
    affiliate: ResourceSelectionState;
}

export const defaultFilter: ResourceSelectionState = { all: true, selected: [] };

export const defaultFilters: PurchaseFilter = {
    date: DateType.PURCHASE_DATE,
    type: defaultFilter,
    product: defaultFilter,
    status: defaultFilter,
    balance: defaultFilter,
    dispute: { ...defaultFilter, showUnassigned: true },
    source: defaultFilter,
    affiliate: { ...defaultFilter, showUnassigned: true },
};

interface PurchaseFilterStoreState {
    from: Dayjs | null;
    to: Dayjs | null;
    filters: PurchaseFilter;
    isRealTimeRefetch: boolean;
    setFilters: (filters: Partial<PurchaseFilter>) => void;
    resetFilters: (filters?: Partial<PurchaseFilter>) => void;
    resetToDefaults: () => void;
    resetDate: () => void;
    setFrom: (date: Dayjs | null) => void;
    setTo: (date: Dayjs | null) => void;
    setIsRealTimeRefetch: (isRealTimeRefetch: boolean) => void;
}

export const usePurchaseFilterStore = create<PurchaseFilterStoreState>((set) => ({
    from: null,
    to: null,
    filters: defaultFilters,
    isRealTimeRefetch: false,
    setFilters(filters: Partial<PurchaseFilter>) {
        set((state) => ({ filters: { ...state.filters, ...filters } }));
    },

    resetFilters(filters?: Partial<PurchaseFilter>) {
        set(() => ({ filters: { ...defaultFilters, ...filters } }));
    },

    setFrom(from: Dayjs | null) {
        set(() => ({ from }));
    },

    setTo(to: Dayjs | null) {
        set(() => ({ to }));
    },

    resetToDefaults() {
        set({
            from: null,
            to: null,
            filters: defaultFilters,
        });
    },
    resetDate() {
        set({ from: null, to: null });
    },
    setIsRealTimeRefetch(isRealTimeRefetch: boolean) {
        set(() => ({ isRealTimeRefetch }));
    },
}));
